import { render, staticRenderFns } from "./historyreport.vue?vue&type=template&id=1df6735a"
import script from "./historyreport.vue?vue&type=script&lang=js"
export * from "./historyreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports